
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 018.527 13H4.562a8.008 8.008 0 005.648 6.667zM10.53 13c.151 2.439.848 4.73 1.97 6.752A15.906 15.906 0 0014.47 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 01-1.683 6.667A8.008 8.008 0 0020.438 13zM4.562 11h3.965a17.9 17.9 0 011.683-6.667A8.008 8.008 0 004.562 11zm5.969 0h3.938A15.904 15.904 0 0012.5 4.248 15.906 15.906 0 0010.53 11h.001zm4.259-6.667A17.9 17.9 0 0116.473 11h3.965a8.008 8.008 0 00-5.648-6.667z","fill":"#FAAD14"}})])
          )
        }
      }
    